export default "__VITE_ASSET__7Gdsysax__"